// extracted by mini-css-extract-plugin
export default {"footerActions":"UNXSKJ","footer":"xkO40B","tickIcon":"d2CHxR","benefit":"YFSY2e","container":"gxXXgR","content":"EvqsHy","heading":"Ncwzvb","benefitWrapper":"zV7lg5"};